import { useDispatch, useSelector } from "react-redux";
// import { teamsData } from "../../assets/teams/data";
import "./BlackLabelTeam.css";
import { hideTeamInfoPanel, selectMember, setTeamsData, showContentSection } from "../../features/serviceSlice";
import { useCallback, useEffect } from "react";
import axios from "axios";

export default function BlackLabelTeam() {
  const dispatch = useDispatch();

  const {
        selectedTeamMember,
        teamsData
    } = useSelector(state => state.service);

  const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API+"/team"
            );

            dispatch(setTeamsData(response.data[0].teams));
            // dispatch(setServiceData(wardrobeSections));

        } catch (error) {
            console.error("API error:", error);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

  return (
    <section className="blacklabelteam-wrapper">
      <div className="blacklabelteam-left">
        <h1>
          Meet the Sudsies®
          <br />
          Black Label Team
        </h1>
      </div>

      <div className="blacklabelteam-right">
        {teamsData.map((member, index) => {
          const fullName = `${member.first_name} ${member.last_name}`.trim();
          const title =
            member.long_title.includes("–")
              ? member.long_title.split("–")[1].trim()
              : member.short_title;

          return (
            <div key={index} className={`team-row ${selectedTeamMember === index ? "active" : ""}`} onClick={(e) => {
              e.stopPropagation();
              dispatch(showContentSection());
              dispatch(hideTeamInfoPanel());
            dispatch(selectMember(index))
          }}>
            {fullName.toUpperCase()}, {title.toUpperCase()}
          </div>
          );
        })}
      </div>
    </section>
  );
}
